export const API_BASE_URL: string = process.env.NEXT_PUBLIC_API_BASE_URL || '';

// TRACKER
// It's our etracker account identifier. It's client side. It's not secure at all. Just etracker's naming.
export const ETRACKER_SECURE_CODE: string = process.env.NEXT_PUBLIC_ETRACKER_SECURE_CODE || '';

export const FB_PIXEL_ID: string = process.env.NEXT_PUBLIC_FB_PIXEL_ID || '';

export const GA_TRACKING_ID: string = process.env.NEXT_PUBLIC_GA_TRACKING_ID || '';

export const LINKEDIN_PIXEL_PARTNER_ID: string =
  process.env.NEXT_PUBLIC_LINKEDIN_PIXEL_PARTNER_ID || '';

// ANALYTICS
export const ADOBE_ANALYTICS_JS_LINK: string =
  process.env.NEXT_PUBLIC_ADOBE_ANALYTICS_JS_LINK || '';

export const MOUSEFLOW_ID: string = process.env.NEXT_PUBLIC_MOUSEFLOW_ID || '';

// GITLAB PIPELINE
export const PIPELINE_ID: string | undefined = process.env.NEXT_PUBLIC_PIPELINE_ID;
export const PIPELINE_CREATED_AT: string | undefined = process.env.NEXT_PUBLIC_PIPELINE_CREATED_AT;
